module.exports = __webpack_public_path__ + "static/media/img_fm-132bde-cover.a421a7b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/img_fm-132bde-cover.png
// module id = 688
// module chunks = 0